export default __webpack_public_path__ + "static/Necto-Mono-d6caa744e6641278c20260995725a8c2.woff2";